import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import IconButton from '../../Button/IconButton';
import BiButton from '../../biLogger/Components/BiButton';
import { BiEventType } from '../../biLogger';
import { MobileContext } from '../../Context';
import { IconSize } from '../../Icons/IconWrap';
import { default as AddCircleIcon } from '../../Icons/AddCircle';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import s from './CommentBoxFooter.scss';
var CommentBoxFooter = function (_a) {
    var Toolbar = _a.toolbar, isEditorBusy = _a.isEditorBusy, isEditorEmpty = _a.isEditorEmpty, isEdit = _a.isEdit, isFallback = _a.isFallback, onCancel = _a.onCancel, onSubmit = _a.onSubmit, onToggleFallback = _a.onToggleFallback, tabIndexBase = _a.tabIndexBase, compact = _a.compact, className = _a.className;
    var t = useTranslation().t;
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var isMobile = useContext(MobileContext);
    var isCollapsable = Toolbar && (compact || isMobile);
    var plaintextFallback = useFlag('plaintext_editor');
    var handleToolbarClick = function (ev) {
        if (isCollapsable) {
            setExpanded(false);
        }
    };
    return (React.createElement("footer", { className: classnames(s['root'], isCollapsable && s['small'], isCollapsable && expanded && s['expanded'], className) },
        !isFallback && Toolbar && (React.createElement("div", { className: s['toolbar-wrapper'] },
            isCollapsable && (React.createElement(IconButton, { className: s['toolbar-toggle'], onClick: function () { return setExpanded(!expanded); } },
                React.createElement(AddCircleIcon, { size: IconSize.MEDIUM }))),
            React.createElement("div", { className: s['toolbar'], onClick: handleToolbarClick },
                React.createElement(Toolbar, { className: s['editor-toolbar'] })))),
        plaintextFallback && (React.createElement("button", { tabIndex: tabIndexBase || 0 + 4, className: classnames(s['fallback-button'], s['button-activated']), onClick: function () {
                if (isEditorEmpty || isFallback || confirm(t('commentbox.prompt.fallback'))) {
                    onToggleFallback();
                }
            } }, t(isFallback ? 'commentbox.button.fullEditor' : 'commentbox.button.fallbackEditor'))),
        React.createElement(BiButton, { tabIndex: tabIndexBase || 0 + 3, disabled: isEditorBusy, className: classnames(s['cancel-button'], s['button-activated']), onClick: onCancel, biData: {
                evid: BiEventType.COMMENT_CANCEL_CLICK,
            } }, t('commentbox.button.cancel')),
        React.createElement("button", { tabIndex: tabIndexBase || 0 + 2, disabled: isEditorEmpty || isEditorBusy, className: classnames(s['comment-button'], isEditorEmpty && s['button-disabled']), onClick: onSubmit }, isEdit
            ? t('commentbox.button.update')
            : t('commentbox.button.comment'))));
};
export default CommentBoxFooter;
//# sourceMappingURL=CommentBoxFooter.js.map